// extracted by mini-css-extract-plugin
export default {"buttons":"privacy_ccpa-buttons_buttons","buttonWrapper":"privacy_ccpa-buttons_buttonWrapper","button":"privacy_ccpa-buttons_button"};